import React from 'react';
import { Logo, Flag, Pill, EntityLink } from './ui';
import { POSITION_PILL, positionFamily } from '../../lib/playerFormatters';

export default function PlayerHero({ player, season, seasonSelect }) {
  const stats = season || player?.currentSeasonStats || {};
  const strip = [
    { l: 'Goals', v: stats.goals },
    { l: 'Assists', v: stats.assists },
    { l: 'Matches', v: stats.appearances },
    { l: 'Age', v: player?.age },
    { l: 'Season', v: stats.seasonName },
  ];
  return (
    <div className="i-card p-5 mb-4">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex flex-wrap items-center gap-4 min-w-0">
          <Logo src={player?.image} alt={player?.name} size={84} fallback={player?.name} />
          <div className="min-w-0">
            <h1 className="i-fg text-2xl font-bold tracking-tight">{player?.name || '—'}</h1>
            <div className="flex flex-wrap items-center gap-2 mt-2">
              <Pill className={POSITION_PILL[positionFamily(player?.position)]}>{player?.position || player?.detailedPosition || '—'}</Pill>
              {player?.currentClub?.id && (
                <EntityLink to={`/club/${player.currentClub.id}`} className="flex items-center gap-1.5">
                  <Pill>
                    <Logo src={player.currentClub.image} alt={player.currentClub.name} size={16} fallback={player.currentClub.name} />
                    <span className="ml-1">{player.currentClub.name || '—'}</span>
                  </Pill>
                </EntityLink>
              )}
              {player?.nationality?.name && (
                <span className="flex items-center gap-1.5 i-mute text-sm">
                  <Flag src={player.nationality.image} alt={player.nationality.name} size={16} />
                  {player.nationality.name}
                </span>
              )}
            </div>
          </div>
        </div>
        {seasonSelect}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 mt-4 pt-4 border-t border-shell-border">
        {strip.map((s, i) => (
          <div key={i} className="i-stat">
            <span className="i-mute text-xs">{s.l}</span>
            <span className="i-fg font-semibold">{s.v == null || s.v === '' ? '—' : s.v}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
